import { render, staticRenderFns } from "./city.vue?vue&type=template&id=05506128"
import script from "./city.vue?vue&type=script&lang=js"
export * from "./city.vue?vue&type=script&lang=js"
import style0 from "./city.vue?vue&type=style&index=0&id=05506128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports